import { createFileRoute } from "@tanstack/react-router"

import { SampleSharePage } from "@/pages/share/sample-share-page"

export const Route = createFileRoute("/share/sample")({
	component: SampleSharePage,
})
